<script>
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "ComingSoonPage",
    components: {Link, MobileTopBar}
}
</script>

<template>
    <MobileTopBar/>
    <div class="container flex flex-col items-center justify-center text-center mt-10">
        <h1 class="text-4xl md:text-5xl font-semibold mb-2 text-gray-800">
            В разработке
        </h1>
        <p class="text-lg text-gray-600 mb-6">
            Мы готовим что-то интересное. Заходите чуть позже!
        </p>
        <Link :href="route('home')"
              class="inline-block px-6 py-3 bg-baseColor text-black rounded-lg md:hover:bg-baseColor/90 transition">
            На главную
        </Link>
    </div>
</template>

<style scoped lang="scss">

</style>
